import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaLeaf, FaMicrochip, FaPiggyBank, FaMapMarkerAlt, FaStar, FaQuoteLeft, FaArrowRight, FaChevronLeft, FaChevronRight, FaEye, FaCalendarAlt, FaCar, FaMagic, FaInstagram, FaFacebook, FaTiktok, FaChevronDown, FaGoogle, FaCheckSquare, FaShieldAlt, FaAward, FaTimes, FaSearchPlus, FaImages, FaClock, FaSyncAlt } from 'react-icons/fa';
import './HomePage.css';
import heroBg from '../assets/hero-bg.png';
import creatorImg from '../assets/hero.jpeg';
import luxe1 from '../assets/interieur-luxe/interieur-luxe1.jpg';
import luxe2 from '../assets/interieur-luxe/interieur-luxe2.jpg';
import luxe3 from '../assets/interieur-luxe/interieur-luxe3.jpg';
import luxe4 from '../assets/interieur-luxe/interieur-luxe4.jpg';
import luxe5 from '../assets/interieur-luxe/interieur-luxe5.jpg';
import luxe6 from '../assets/interieur-luxe/interieur-luxe6.jpg';
import luxe7 from '../assets/interieur-luxe/interieur-luxe7.jpg';
import luxe8 from '../assets/interieur-luxe/interieur-luxe8.jpg';
import luxe9 from '../assets/interieur-luxe/interieur-luxe9.jpg';
import luxe10 from '../assets/interieur-luxe/interieur-luxe10.jpg';
import luxe11 from '../assets/interieur-luxe/interieur-luxe11.jpg';
import luxe12 from '../assets/interieur-luxe/interieur-luxe12.jpg';
import luxe13 from '../assets/interieur-luxe/interieur-luxe13.jpg';
import luxe14 from '../assets/interieur-luxe/interieur-luxe14.jpg';
import luxe15 from '../assets/interieur-luxe/interieur-luxe15.jpg';
import luxe16 from '../assets/interieur-luxe/interieur-luxe16.jpg';
import luxe17 from '../assets/interieur-luxe/interieur-luxe17.jpg';
import luxe18 from '../assets/interieur-luxe/interieur-luxe18.jpg';

import pb from '../pocketbase';
import TrustMap from '../components/TrustMap';
import ComparisonSlider from '../components/ComparisonSlider';
import FeeCalculator from '../components/FeeCalculator';
import FAQSection from '../components/FAQSection';

// Reviews Data
const REVIEWS = [
    {
        id: 1,
        name: "Laurine",
        role: "Local Guide",
        date: "il y a 5 mois",
        initial: "L",
        content: "Un travail de très grande qualité autant pour ma voiture que mon canapé. C’était impressionnant, ils ont fini comme neufs. Jérémie a fait preuve de beaucoup de professionnalisme et de ponctualité et est en + très sympathique. Merci beaucoup, nous referons appel à vos services. Vous pouvez foncer.",
        stars: 5,
        color: "#4285F4"
    },
    {
        id: 2,
        name: "Marc D.",
        role: "Client Vérifié",
        date: "il y a 2 mois",
        initial: "M",
        content: "Nettoyage complet de mon SUV avant la vente. Le résultat est bluffant, le futur acheteur a cru que la voiture sortait de concession. Je recommande vivement RoulezPropre pour le soin apporté aux détails.",
        stars: 5,
        color: "#34A853"
    },
    {
        id: 3,
        name: "Sophie L.",
        role: "Cliente Fidèle",
        date: "il y a 3 semaines",
        initial: "S",
        content: "Impressionnée par le nettoyage de mon canapé en tissu ! Les taches de café ont complètement disparu. C'est rapide, propre et pro. Merci Jérémie !",
        stars: 5,
        color: "#EA4335"
    }
];

// Images
const CREATOR_IMG = "https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80";

// Hero Slider Data
const HERO_SLIDES = [
    {
        id: 1,
        badge: "4.9/5 · 150+ Avis Google",
        title: "ROULEZ",
        titleHighlight: "PROPRE",
        subtitle: "La propreté Roule avec nous",
        description: "Service professionnel de nettoyage automobile et mobilier à domicile",
        image: luxe1,
        primaryCTA: { text: "Nos Prestations", link: "#services" },
        secondaryCTA: { text: "Devis gratuit", link: "/contact" }
    },
    {
        id: 2,
        badge: "4.9/5 · 150+ Avis Google",
        title: "NETTOYAGE",
        titleHighlight: "ÉCO-FRIENDLY",
        subtitle: "97% de produits biosourcés",
        description: "Respectueux de l'environnement et de votre santé",
        image: luxe2,
        primaryCTA: { text: "Nos Engagements", link: "#services" },
        secondaryCTA: { text: "Réserver", link: "/contact" }
    },
    {
        id: 3,
        badge: "4.9/5 · 150+ Avis Google",
        title: "COMME",
        titleHighlight: "NEUF",
        subtitle: "Votre voiture mérite le meilleur",
        description: "Des résultats professionnels qui dépassent vos attentes",
        image: luxe3,
        primaryCTA: { text: "Nos Formules", link: "/nettoyage-voiture" },
        secondaryCTA: { text: "Avant/Après", link: "/avant-apres" }
    }
];

// Hero Slider Component
const HeroSlider = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [direction, setDirection] = useState(1);

    useEffect(() => {
        const timer = setInterval(() => {
            setDirection(1);
            setCurrentSlide((prev) => (prev + 1) % HERO_SLIDES.length);
        }, 7000);
        return () => clearInterval(timer);
    }, []);

    const nextSlide = () => {
        setDirection(1);
        setCurrentSlide((prev) => (prev + 1) % HERO_SLIDES.length);
    };

    const prevSlide = () => {
        setDirection(-1);
        setCurrentSlide((prev) => (prev - 1 + HERO_SLIDES.length) % HERO_SLIDES.length);
    };

    const goToSlide = (index) => {
        setDirection(index > currentSlide ? 1 : -1);
        setCurrentSlide(index);
    };

    const slideVariants = {
        enter: {
            opacity: 0,
            scale: 1.1
        },
        center: {
            zIndex: 1,
            opacity: 1,
            scale: 1
        },
        exit: {
            zIndex: 0,
            opacity: 0,
            scale: 0.95,
            transition: { duration: 0.8 }
        }
    };

    return (
        <section className="hero-slider-section">
            <AnimatePresence initial={false}>
                <motion.div
                    key={currentSlide}
                    variants={slideVariants}
                    initial="enter"
                    animate="center"
                    exit="exit"
                    transition={{
                        opacity: { duration: 1, ease: "easeInOut" },
                        scale: { duration: 1.2, ease: "easeOut" }
                    }}
                    className="hero-slide"
                >
                    <div className="hero-bg-container">
                        <motion.img
                            src={HERO_SLIDES[currentSlide].image}
                            alt="Hero Background"
                            className="hero-bg"
                            initial={{ scale: 1 }}
                            animate={{ scale: 1.15 }}
                            transition={{
                                duration: 10,
                                ease: "linear",
                                repeat: Infinity,
                                repeatType: "reverse"
                            }}
                        />
                        <div className="hero-overlay"></div>
                    </div>

                    <div className="container hero-container">
                        <div className="hero-flex-wrapper">
                            <motion.div
                                className="hero-content"
                                initial={{ opacity: 0, y: 50 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.2, duration: 0.8 }}
                            >
                                <motion.div
                                    className={`hero-badge ${HERO_SLIDES[currentSlide].badge.includes('Google') ? 'google-badge' : ''}`}
                                    initial={{ opacity: 0, scale: 0.8 }}
                                    animate={{ opacity: 1, scale: 1 }}
                                    transition={{ delay: 0.3, duration: 0.5 }}
                                >
                                    {HERO_SLIDES[currentSlide].badge.includes('Google') ? (
                                        <>
                                            <FaGoogle style={{ marginRight: '8px', color: '#4285F4' }} />
                                            <span className="stars-group" style={{ marginRight: '8px' }}>
                                                <FaStar color="#FBBC05" size={12} />
                                                <FaStar color="#FBBC05" size={12} />
                                                <FaStar color="#FBBC05" size={12} />
                                                <FaStar color="#FBBC05" size={12} />
                                                <FaStar color="#FBBC05" size={12} />
                                            </span>
                                            {HERO_SLIDES[currentSlide].badge}
                                        </>
                                    ) : (
                                        <>
                                            <FaAward style={{ marginRight: '8px' }} />
                                            {HERO_SLIDES[currentSlide].badge}
                                        </>
                                    )}
                                </motion.div>
                                
                                {/* QR Code visible uniquement sur mobile entre le badge et le titre */}
                                <motion.div 
                                    className="hero-qr-mobile-only"
                                    initial={{ opacity: 0, scale: 0.8 }}
                                    animate={{ opacity: 1, scale: 1 }}
                                    transition={{ delay: 0.4, duration: 0.5 }}
                                >
                                    <div className="qr-mini-scanner" onClick={() => document.dispatchEvent(new CustomEvent('openQrModal'))} style={{ cursor: 'pointer' }}>
                                        <img 
                                            src={`https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=${window.location.origin}/reservation&color=1f2937`} 
                                            alt="Scan to book" 
                                        />
                                        <div className="qr-mini-line"></div>
                                    </div>
                                    <Link to="/reservation" className="qr-mini-text" style={{ textDecoration: 'none' }}>
                                        <span>RÉSERVER EN 1 CLIC</span>
                                        <small>Gagnez du temps</small>
                                    </Link>
                                </motion.div>

                                <motion.h1
                                    className="hero-title"
                                    initial={{ opacity: 0, y: 30 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ delay: 0.4, duration: 0.8 }}
                                >
                                    {HERO_SLIDES[currentSlide].title} <span className="text-blue">{HERO_SLIDES[currentSlide].titleHighlight}</span>
                                </motion.h1>

                                <motion.p
                                    className="hero-subtitle"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ delay: 0.5, duration: 0.8 }}
                                >
                                    {HERO_SLIDES[currentSlide].subtitle}
                                </motion.p>

                                <motion.p
                                    className="hero-description"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ delay: 0.6, duration: 0.8 }}
                                >
                                    {HERO_SLIDES[currentSlide].description}
                                </motion.p>

                                <motion.div
                                    className="hero-buttons"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ delay: 0.7, duration: 0.8 }}
                                >
                                    <a href={HERO_SLIDES[currentSlide].primaryCTA.link} className="btn btn-primary">
                                        {HERO_SLIDES[currentSlide].primaryCTA.text} <FaArrowRight />
                                    </a>
                                    <Link to={HERO_SLIDES[currentSlide].secondaryCTA.link} className="btn btn-outline">
                                        {HERO_SLIDES[currentSlide].secondaryCTA.text}
                                    </Link>
                                </motion.div>
                            </motion.div>

                            {/* Interactive QR Booking Card (Centered in right space) */}
                            <motion.div
                                className="hero-qr-card"
                                initial={{ opacity: 0, x: 50 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ delay: 1, duration: 0.8 }}
                            >
                                <div className="qr-card-header">
                                    <span className="qr-status-dot"></span>
                                    <span className="qr-card-title">RÉSERVATION MOBILE</span>
                                </div>

                                <div className="qr-card-body">
                                    <div className="qr-card-image-wrapper" onClick={() => document.dispatchEvent(new CustomEvent('openQrModal'))} style={{ cursor: 'pointer' }}>
                                        <img
                                            src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${window.location.origin}/reservation&color=1f2937`}
                                            alt="Scan to Book"
                                        />
                                        <div className="qr-scan-line"></div>
                                    </div>
                                    <p className="qr-card-desc">Cliquez pour agrandir</p>
                                </div>

                                <div className="qr-card-footer">
                                    <Link to="/reservation" className="qr-action-btn">
                                        <FaCalendarAlt /> PRENDRE RDV
                                    </Link>
                                    <div className="qr-steps-list">
                                        <span className="qr-step">1. Scannez</span>
                                        <span className="qr-step">2. Choisissez</span>
                                        <span className="qr-step">3. Validez</span>
                                    </div>
                                </div>
                            </motion.div>
                        </div>
                    </div>
                </motion.div>
            </AnimatePresence>

            {/* Navigation Controls */}
            <div className="hero-slider-controls">
                <button onClick={prevSlide} className="hero-nav-btn prev" aria-label="Slide précédent">
                    <FaChevronLeft />
                </button>
                <button onClick={nextSlide} className="hero-nav-btn next" aria-label="Slide suivant">
                    <FaChevronRight />
                </button>
            </div>

            {/* Slide Indicators */}
            <div className="hero-slider-indicators">
                {HERO_SLIDES.map((_, index) => (
                    <button
                        key={index}
                        onClick={() => goToSlide(index)}
                        className={`indicator ${index === currentSlide ? 'active' : ''}`}
                        aria-label={`Aller au slide ${index + 1}`}
                    >
                        <span className="indicator-progress"></span>
                    </button>
                ))}
            </div>
        </section >
    );
};


// Custom Interactive Slider Component
const INSTA_POSTS = [
    { id: 1, img: "https://images.unsplash.com/photo-1601362840469-51e4d8d59db2?w=500&q=80", link: "https://www.instagram.com/p/DSK3CVJirxl/" },
    { id: 2, img: "https://images.unsplash.com/photo-1552930294-6b595f4c2974?w=500&q=80", link: "https://www.instagram.com/p/DSIV5H-iun5/" },
    { id: 3, img: "https://images.unsplash.com/photo-1507136566006-cfc505b114fc?w=500&q=80", link: "https://www.instagram.com/p/DSNlsOGinGc/" },
    { id: 4, img: "https://images.unsplash.com/photo-1549399542-7e3f8b79c341?w=500&q=80", link: "https://www.instagram.com/p/DSYCBwsilao/" },
    { id: 5, img: "https://images.unsplash.com/photo-1632823469850-249d332fab51?w=500&q=80", link: "https://www.instagram.com/p/DSiGor8Cpg7/" },
    { id: 6, img: "https://images.unsplash.com/photo-1517524008697-84bbe3c3fd98?w=500&q=80", link: "https://www.instagram.com/p/DSxpyUVim3t/" }
];

const BeforeAfterSlider = ({ beforeImg, afterImg }) => {
    const [sliderPos, setSliderPos] = useState(50);
    const [isDragging, setIsDragging] = useState(false);

    const handleMove = (clientX, rect) => {
        const x = clientX - rect.left;
        const pos = Math.max(0, Math.min(100, (x / rect.width) * 100));
        setSliderPos(pos);
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        handleMove(e.clientX, e.currentTarget.getBoundingClientRect());
    };

    const handleTouchMove = (e) => {
        handleMove(e.touches[0].clientX, e.currentTarget.getBoundingClientRect());
    };

    return (
        <div
            className="ba-slider-wrapper"
            onMouseDown={() => setIsDragging(true)}
            onMouseUp={() => setIsDragging(false)}
            onMouseLeave={() => setIsDragging(false)}
            onMouseMove={handleMouseMove}
            onTouchMove={handleTouchMove}
            onDragStart={(e) => e.preventDefault()}
        >
            <div className="ba-slider-container">
                <div className="after-image">
                    <img src={afterImg} alt="Après" draggable={false} onContextMenu={e => e.preventDefault()} />
                    <div className="ba-label after">Après</div>
                </div>
                <div
                    className="before-image"
                    style={{ width: `${sliderPos}%` }}
                >
                    <img src={beforeImg} alt="Avant" draggable={false} onContextMenu={e => e.preventDefault()} />
                    <div className="ba-label before">Avant</div>
                </div>
                <div
                    className="slider-handle"
                    style={{ left: `${sliderPos}%` }}
                >
                    <div className="handle-line"></div>
                    <div className="handle-button">
                        <FaChevronLeft />
                        <FaChevronRight />
                    </div>
                </div>
            </div>
            <div className="slider-instructions">
                Glissez pour comparer
            </div>
        </div>
    );
};




const GALLERY_PHOTOS = [
    { id: 1, src: luxe1, title: "Reflet Miroir", delay: 0.1, large: true },
    { id: 2, src: luxe2, title: "Détail Cuir", delay: 0.2 },
    { id: 3, src: luxe3, title: "Habitacle Clean", delay: 0.3 },
    { id: 4, src: luxe4, title: "Vapeur HP", delay: 0.4 },
    { id: 5, src: luxe5, title: "Prêt à Rouler", delay: 0.5, large: true },
    { id: 6, src: luxe6, title: "Clean Dashboard", delay: 0.6 },
    { id: 7, src: luxe7, title: "Tapis Neufs", delay: 0.7 },
    { id: 8, src: luxe8, title: "Contre-porte", delay: 0.8 },
    { id: 9, src: luxe9, title: "Console Centrale", delay: 0.9, large: true },
    { id: 10, src: luxe10, title: "Volant Cuir", delay: 1.0 },
    { id: 11, src: luxe11, title: "Aspiration Profonde", delay: 1.1 },
    { id: 12, src: luxe12, title: "Détourage Logos", delay: 1.2 },
    { id: 13, src: luxe13, title: "Pédalier Sport", delay: 1.3 },
    { id: 14, src: luxe14, title: "Ciel de Toit", delay: 1.4, large: true },
    { id: 15, src: luxe15, title: "Plage Arrière", delay: 1.5 },
    { id: 16, src: luxe16, title: "Accoudoir", delay: 1.6 },
    { id: 17, src: luxe17, title: "Grilles d'Aération", delay: 1.7 },
    { id: 18, src: luxe18, title: "Finition Premium", delay: 1.8 }
];

const HomePage = () => {
    const [featuredComparisons, setFeaturedComparisons] = useState([]);
    const [currentCompIndex, setCurrentCompIndex] = useState(0);

    // Lightbox states
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [lightboxIndex, setLightboxIndex] = useState(0);
    const [showBefore, setShowBefore] = useState(false);
    const [isZoomed, setIsZoomed] = useState(false);
    const [zoomPos, setZoomPos] = useState({ x: 0, y: 0 });

    // Keyboard Navigation & Zoom Reset
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (!lightboxOpen) return;
            if (e.key === 'ArrowRight') setLightboxIndex((prev) => (prev === GALLERY_PHOTOS.length - 1 ? 0 : prev + 1));
            if (e.key === 'ArrowLeft') setLightboxIndex((prev) => (prev === 0 ? GALLERY_PHOTOS.length - 1 : prev - 1));
            if (e.key === 'Escape') setLightboxOpen(false);
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [lightboxOpen]);

    useEffect(() => {
        setIsZoomed(false);
        setShowBefore(false);
    }, [lightboxIndex]);

    // Exit Fullscreen on Close
    useEffect(() => {
        if (!lightboxOpen && document.fullscreenElement) {
            document.exitFullscreen().catch(err => console.log("Exit Fullscreen error:", err));
        }
    }, [lightboxOpen]);

    const toggleFullscreen = () => {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen();
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            }
        }
    };
    const handleZoomMove = (e) => {
        if (!isZoomed) return;
        const { left, top, width, height } = e.currentTarget.getBoundingClientRect();
        const x = ((e.pageX - left - window.scrollX) / width) * 100;
        const y = ((e.pageY - top - window.scrollY) / height) * 100;
        setZoomPos({ x, y });
    };

    // Responsive Gallery Count (Option 1: Nombre d'Or)
    const [visiblePhotosCount, setVisiblePhotosCount] = useState(8);

    useEffect(() => {
        const updateCount = () => {
            const width = window.innerWidth;
            if (width >= 1200) setVisiblePhotosCount(6); // 3 columns * 2 rows
            else if (width >= 768) setVisiblePhotosCount(6); // 3 columns * 2 rows
            else setVisiblePhotosCount(4); // 2 columns * 2 rows
        };

        updateCount();
        window.addEventListener('resize', updateCount);
        return () => window.removeEventListener('resize', updateCount);
    }, []);


    useEffect(() => {
        const loadFeaturedComparisons = async () => {
            try {
                // Fetch from 'realisations' collection
                const records = await pb.collection('realisations').getList(1, 20, {
                    filter: 'publier_home = true',
                    sort: '-date'
                });

                const slides = [];
                records.items.forEach(rec => {
                    // With maxSelect: 99, these fields are arrays of filenames. 
                    // PB SDK usually returns them as arrays if multiple are allowed, 
                    // but sometimes single string if only 1 file? 
                    // Actually for multiple files on PB it is always an array of strings in JSON response.

                    const avant = rec.photo_avant || [];
                    const apres = rec.photo_apres || [];

                    // We match by index. If lengths differ, we take minimum.
                    const count = Math.min(avant.length, apres.length);

                    for (let i = 0; i < count; i++) {
                        slides.push({
                            id: rec.id + '_' + i,
                            original_record: rec,
                            photo_avant: avant[i],
                            photo_apres: apres[i],
                            label: rec.titre + (count > 1 ? ` (${i + 1}/${count})` : ''),
                            client: rec.client_nom,
                            category: rec.categorie || 'auto'
                        });
                    }
                });

                setFeaturedComparisons(slides);
            } catch (err) {
                console.log("No featured comparisons or error", err);
            }
        };
        loadFeaturedComparisons();

        // Load Instagram Embed Script
        const script = document.createElement('script');
        script.src = "//www.instagram.com/embed.js";
        script.async = true;
        document.body.appendChild(script);

        return () => {
            if (document.body.contains(script)) {
                document.body.removeChild(script);
            }
        };
    }, []);

    const nextComp = () => {
        setCurrentCompIndex((prev) => (prev + 1) % featuredComparisons.length);
    };

    const prevComp = () => {
        setCurrentCompIndex((prev) => (prev - 1 + featuredComparisons.length) % featuredComparisons.length);
    };

    return (
        <div className="home-page">

            {/* Hero Slider Section */}
            <HeroSlider />

            {/* Personalized Intro Section - Premium Enhanced */}
            <section className="about-me-section">
                <div className="container">
                    <div className="about-grid">
                        <motion.div
                            className="about-image"
                            initial={{ opacity: 0, x: -50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.8, ease: "easeOut" }}
                        >
                            <motion.img
                                src={creatorImg}
                                alt="Jérémie de RoulezPropre"
                                whileHover={{ scale: 1.02 }}
                                transition={{ duration: 0.4 }}
                            />
                            <motion.div
                                className="experience-badge"
                                initial={{ scale: 0, opacity: 0 }}
                                whileInView={{ scale: 1, opacity: 1 }}
                                viewport={{ once: true }}
                                transition={{ delay: 0.5, type: "spring", stiffness: 100 }}
                            >
                                <strong>5+</strong>
                                <span>Ans d'expérience</span>
                            </motion.div>
                        </motion.div>

                        <motion.div
                            className="about-content"
                            initial={{ opacity: 0, x: 50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.8, ease: "easeOut" }}
                        >
                            <motion.span
                                className="section-label"
                                initial={{ opacity: 0, y: 10 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: 0.2 }}
                            >
                                À Propos
                            </motion.span>
                            <motion.h2
                                className="section-title"
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: 0.3 }}
                            >
                                Salut, je suis <span className="text-blue">Jérémie</span>
                            </motion.h2>
                            <motion.p
                                className="about-text"
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: 0.4 }}
                            >
                                Fondateur de <span className="font-bold">RoulezPropre</span>, ma mission est simple : redonner vie à vos intérieurs.
                                Que ce soit pour votre véhicule ou votre canapé, je mets un point d'honneur à utiliser des méthodes
                                <span className="text-blue font-bold"> respectueuses de l'environnement</span> et des produits de haute qualité.
                            </motion.p>
                            <motion.p
                                className="about-text"
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: 0.5 }}
                            >
                                À l'écoute de chaque détail, je m'engage à fournir un service <span className="text-blue font-bold">professionnel, fiable et performant</span> directement chez vous ou sur votre lieu de travail.
                            </motion.p>
                            <div className="about-stats">
                                <motion.div
                                    className="stat-item"
                                    initial={{ opacity: 0, y: 20 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ delay: 0.6 }}
                                >
                                    <strong>500+</strong>
                                    <span>Véhicules nettoyés</span>
                                </motion.div>
                                <motion.div
                                    className="stat-item"
                                    initial={{ opacity: 0, y: 20 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ delay: 0.7 }}
                                >
                                    <strong>100%</strong>
                                    <span>Satisfaction</span>
                                </motion.div>
                            </div>
                        </motion.div>
                    </div>
                </div>
            </section>

            {/* How It Works Section - Premium Enhanced */}
            <section className="how-it-works-premium">
                <div className="container">
                    <motion.div
                        className="section-header text-center"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6 }}
                    >
                        <motion.span
                            className="section-label"
                            initial={{ opacity: 0, scale: 0.8 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true }}
                            transition={{ delay: 0.2, duration: 0.5 }}
                        >
                            <FaCheckCircle style={{ marginRight: '8px' }} />
                            Le Processus
                        </motion.span>
                        <motion.h2
                            className="section-title"
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: 0.3, duration: 0.6 }}
                        >
                            Comment <span className="text-gradient-blue">ça marche</span> ?
                        </motion.h2>
                        <motion.p
                            className="section-subtitle-text"
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: 0.4, duration: 0.6 }}
                        >
                            Un service simple et efficace en 3 étapes
                        </motion.p>
                    </motion.div>

                    <div className="steps-grid-premium">
                        {/* Step 1 */}
                        <motion.div
                            className="step-card-premium"
                            whileHover={{ y: -10, transition: { duration: 0.3 } }}
                        >
                            <div className="step-connector"></div>
                            <motion.div
                                className="step-number-badge"
                            >
                                01
                            </motion.div>
                            <motion.div
                                className="step-icon-wrapper"
                                whileHover={{ scale: 1.1, rotate: 5 }}
                            >
                                <FaCalendarAlt />
                            </motion.div>
                            <motion.h4
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: 0.9, duration: 0.5 }}
                            >
                                Réservation
                            </motion.h4>
                            <motion.p
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: 1, duration: 0.5 }}
                            >
                                Choisissez votre prestation en ligne ou contactez-nous par téléphone/WhatsApp pour fixer un rendez-vous.
                            </motion.p>
                            <div className="step-glow step-glow-1"></div>
                        </motion.div>

                        {/* Step 2 */}
                        <motion.div
                            className="step-card-premium"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: 0.6, duration: 0.7 }}
                            whileHover={{ y: -10, transition: { duration: 0.3 } }}
                        >
                            <div className="step-connector"></div>
                            <motion.div
                                className="step-number-badge"
                                initial={{ scale: 0 }}
                                whileInView={{ scale: 1 }}
                                viewport={{ once: true }}
                                transition={{ delay: 0.8, type: "spring", stiffness: 200 }}
                            >
                                02
                            </motion.div>
                            <motion.div
                                className="step-icon-wrapper"
                                initial={{ rotate: -180, opacity: 0 }}
                                whileInView={{ rotate: 0, opacity: 1 }}
                                viewport={{ once: true }}
                                transition={{ delay: 0.9, duration: 0.6 }}
                                whileHover={{ scale: 1.1, rotate: 5 }}
                            >
                                <FaCar />
                            </motion.div>
                            <motion.h4
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: 1, duration: 0.5 }}
                            >
                                Intervention
                            </motion.h4>
                            <motion.p
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: 1.1, duration: 0.5 }}
                            >
                                Je me déplace directement chez vous ou sur votre lieu de travail avec tout le matériel professionnel nécessaire.
                            </motion.p>
                            <div className="step-glow step-glow-2"></div>
                        </motion.div>

                        {/* Step 3 */}
                        <motion.div
                            className="step-card-premium"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: 0.7, duration: 0.7 }}
                            whileHover={{ y: -10, transition: { duration: 0.3 } }}
                        >
                            <motion.div
                                className="step-number-badge"
                                initial={{ scale: 0 }}
                                whileInView={{ scale: 1 }}
                                viewport={{ once: true }}
                                transition={{ delay: 0.9, type: "spring", stiffness: 200 }}
                            >
                                03
                            </motion.div>
                            <motion.div
                                className="step-icon-wrapper"
                                initial={{ rotate: -180, opacity: 0 }}
                                whileInView={{ rotate: 0, opacity: 1 }}
                                viewport={{ once: true }}
                                transition={{ delay: 1, duration: 0.6 }}
                                whileHover={{ scale: 1.1, rotate: 5 }}
                            >
                                <FaMagic />
                            </motion.div>
                            <motion.h4
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: 1.1, duration: 0.5 }}
                            >
                                Résultat
                            </motion.h4>
                            <motion.p>
                                Retrouvez votre véhicule ou mobilier comme neuf, avec une protection durable et une odeur de propre.
                            </motion.p>
                            <div className="step-glow step-glow-3"></div>
                        </motion.div>
                    </div>
                </div>
            </section>

            {/* Comparison Slider Section */}
            <section className="demo-slider-section">
                <div className="container">
                    <div className="section-header text-center">
                        <span className="section-label">Démonstration</span>
                        <h2 className="section-title">Voyez la métamorphose</h2>
                        <p className="section-subtitle-text">Faites glisser le curseur pour comparer nos résultats en un clin d'œil</p>
                    </div>

                    {featuredComparisons.length > 0 ? (
                        <div className="dynamic-comparison-wrapper">
                            <ComparisonSlider
                                before={pb.files.getUrl(featuredComparisons[currentCompIndex].original_record, featuredComparisons[currentCompIndex].photo_avant)}
                                after={pb.files.getUrl(featuredComparisons[currentCompIndex].original_record, featuredComparisons[currentCompIndex].photo_apres)}
                            />

                            {/* Navigation */}
                            {featuredComparisons.length > 1 && (
                                <div className="comp-navigation">
                                    <button onClick={prevComp} className="comp-nav-btn"><FaChevronLeft /> Précédent</button>
                                    <span className="comp-counter">{currentCompIndex + 1} / {featuredComparisons.length}</span>
                                    <button onClick={nextComp} className="comp-nav-btn">Suivant <FaChevronRight /></button>
                                </div>
                            )}

                        </div>
                    ) : (
                        <ComparisonSlider
                            before="https://images.unsplash.com/photo-1620334885743-3058a2d1d56d?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80"
                            after="https://images.unsplash.com/photo-1552519507-da3b142c6e3d?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80"
                        />
                    )}
                </div>
            </section>



            {/* Trust Map Section */}
            <TrustMap onAddressSelect={(data) => window.dispatchEvent(new CustomEvent('map-update', { detail: data }))} />
            <FeeCalculator onAddressSelect={(data) => window.dispatchEvent(new CustomEvent('map-update', { detail: data }))} />

            {/* Gallery Section - Premium Enhanced */}
            <section className="gallery-section-premium">
                <div className="container">
                    <motion.div
                        className="section-header text-center"
                    >
                        <motion.span
                            className="section-label"
                        >
                            <FaImages style={{ marginRight: '8px' }} />
                            Réalisations
                        </motion.span>
                        <motion.h2
                            className="section-title"
                        >
                            Galerie <span className="text-gradient-blue">Photos</span>
                        </motion.h2>
                        <motion.p
                            className="section-subtitle-text"
                            style={{ 
                                marginTop: '20px', 
                                fontSize: '1.2rem', 
                                color: 'var(--text-secondary)',
                                maxWidth: '700px',
                                margin: '20px auto 0'
                            }}
                        >
                            Des résultats impeccables qui parlent d'eux-mêmes
                        </motion.p>
                    </motion.div>

                    <div className="gallery-grid-premium">
                        {GALLERY_PHOTOS.slice(0, visiblePhotosCount).map((photo, index) => (
                            <motion.div
                                key={photo.id}
                                className={`gallery-item-premium ${photo.large ? 'large-item' : ''}`}
                                whileHover={{ y: -10, transition: { duration: 0.3 } }}
                                onClick={() => {
                                    setLightboxOpen(true);
                                    setLightboxIndex(index);
                                }}
                            >
                                <div className="gallery-img-wrapper">
                                    <img src={photo.src} alt={photo.title} />
                                    <div className="gallery-overlay">
                                        <motion.div
                                            className="overlay-content"
                                            initial={{ opacity: 0, scale: 0.8 }}
                                            whileHover={{ opacity: 1, scale: 1 }}
                                            transition={{ duration: 0.3 }}
                                        >
                                            <FaSearchPlus className="zoom-icon" />
                                            <span className="photo-title">{photo.title}</span>
                                        </motion.div>
                                    </div>
                                </div>
                                <div className="gallery-glow"></div>
                            </motion.div>
                        ))}
                    </div>

                    <motion.div
                        className="text-center mt-60"
                    >
                        <Link to="/avant-apres" className="btn-gallery-premium">
                            <span>Voir toutes nos réalisations</span>
                            <motion.div
                                className="btn-icon"
                                whileHover={{ x: 5 }}
                                transition={{ duration: 0.3 }}
                            >
                                <FaArrowRight />
                            </motion.div>
                        </Link>
                    </motion.div>
                </div>

                {/* Lightbox - Premium Studio Version */}
                <AnimatePresence>
                    {lightboxOpen && (
                        <motion.div
                            className="lightbox-overlay-premium"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.4 }}
                            onClick={() => setLightboxOpen(false)}
                        >
                            {/* Top Bar - Progress & Close */}
                            <div className="lightbox-top-bar">
                                <div className="lightbox-progress-container">
                                    <div
                                        className="lightbox-progress-bar"
                                        style={{ width: `${((lightboxIndex + 1) / 5) * 100}%` }}
                                    ></div>
                                </div>
                                <div className="lightbox-top-actions">
                                    <motion.button
                                        className="lightbox-action-btn"
                                        whileHover={{ scale: 1.1 }}
                                        whileTap={{ scale: 0.9 }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            toggleFullscreen();
                                        }}
                                        title="Plein écran"
                                    >
                                        <FaEye />
                                    </motion.button>
                                    <motion.button
                                        className="lightbox-close-minimal"
                                        whileHover={{ scale: 1.1, rotate: 90 }}
                                        whileTap={{ scale: 0.9 }}
                                        onClick={() => setLightboxOpen(false)}
                                    >
                                        <FaTimes />
                                    </motion.button>
                                </div>
                            </div>

                            {/* Main Content with Sliding Animation */}
                            <div className="lightbox-main-container" onClick={(e) => e.stopPropagation()}>
                                <motion.button
                                    className="lightbox-nav-minimal lightbox-prev"
                                    whileHover={{ scale: 1.1, x: -5 }}
                                    whileTap={{ scale: 0.9 }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setLightboxIndex((prev) => (prev === 0 ? GALLERY_PHOTOS.length - 1 : prev - 1));
                                    }}
                                >
                                    <FaChevronLeft />
                                </motion.button>

                                <div className="lightbox-image-viewport">
                                    <AnimatePresence mode="wait">
                                        <motion.div
                                            key={`${lightboxIndex}-${showBefore}`}
                                            initial={{ opacity: 0, scale: 0.95 }}
                                            animate={{ opacity: 1, scale: 1 }}
                                            exit={{ opacity: 0, scale: 0.95 }}
                                            transition={{ duration: 0.3 }}
                                            className="lightbox-image-wrapper"
                                        >
                                            <div
                                                className={`lightbox-img-container ${isZoomed ? 'zoomed' : ''}`}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setIsZoomed(!isZoomed);
                                                }}
                                                onMouseMove={handleZoomMove}
                                                style={{ cursor: isZoomed ? 'zoom-out' : 'zoom-in' }}
                                            >
                                                <img
                                                    src={showBefore ? GALLERY_PHOTOS[lightboxIndex].before : GALLERY_PHOTOS[lightboxIndex].src}
                                                    alt={GALLERY_PHOTOS[lightboxIndex].title}
                                                    className="lightbox-img-premium"
                                                />

                                                {isZoomed && (
                                                    <div
                                                        className="lightbox-loupe"
                                                        style={{
                                                            backgroundImage: `url(${showBefore ? GALLERY_PHOTOS[lightboxIndex].before : GALLERY_PHOTOS[lightboxIndex].src})`,
                                                            backgroundPosition: `${zoomPos.x}% ${zoomPos.y}%`,
                                                            left: `${zoomPos.x}%`,
                                                            top: `${zoomPos.y}%`,
                                                            transform: 'translate(-50%, -50%)'
                                                        }}
                                                    ></div>
                                                )}

                                            </div>
                                        </motion.div>
                                    </AnimatePresence>
                                </div>

                                <motion.button
                                    className="lightbox-nav-minimal lightbox-next"
                                    whileHover={{ scale: 1.1, x: 5 }}
                                    whileTap={{ scale: 0.9 }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setLightboxIndex((prev) => (prev === GALLERY_PHOTOS.length - 1 ? 0 : prev + 1));
                                    }}
                                >
                                    <FaChevronRight />
                                </motion.button>
                            </div>

                            {/* Thumbnails Strip */}
                            <div className="lightbox-thumbnails-strip" onClick={(e) => e.stopPropagation()}>
                                {GALLERY_PHOTOS.map((photo, idx) => (
                                    <motion.div
                                        key={idx}
                                        className={`thumbnail-item ${idx === lightboxIndex ? 'active' : ''}`}
                                        whileHover={{ y: -5 }}
                                        onClick={() => setLightboxIndex(idx)}
                                    >
                                        <img src={photo.src} alt={`Thumbnail ${idx + 1}`} />
                                    </motion.div>
                                ))}
                            </div>
                        </motion.div>
                    )}
                </AnimatePresence>
            </section>


            {/* Google Reviews Slider - Premium Glassmorphism */}
            <section className="reviews-slider-section">
                <div className="container">
                    <motion.div 
                        className="section-header text-center"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                    >
                        <span className="section-label">TÉMOIGNAGES</span>
                        <h2 className="section-title">Ce que <span className="text-gradient-blue">disent nos clients</span></h2>
                        <div className="google-rating-summary">
                            <div className="google-logo-wrapper">
                                <FaGoogle />
                            </div>
                            <div className="rating-info">
                                <span className="rating-val">4.9/5</span>
                                <div className="stars-row">
                                    <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
                                </div>
                                <span className="reviews-count">Basé sur 150+ avis Google</span>
                            </div>
                        </div>
                    </motion.div>

                    <div className="reviews-grid">
                        {REVIEWS.map((review, index) => (
                            <motion.div 
                                key={review.id}
                                className="review-card-glass"
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: index * 0.1 }}
                                whileHover={{ y: -5 }}
                            >
                                <div className="review-card-header">
                                    <div className="user-avatar" style={{ backgroundColor: review.color }}>
                                        {review.initial}
                                    </div>
                                    <div className="user-info">
                                        <h4>{review.name}</h4>
                                        <p>{review.role} • {review.date}</p>
                                    </div>
                                    <div className="google-icon-small">
                                        <FaGoogle />
                                    </div>
                                </div>
                                <div className="stars-row-card">
                                    {[...Array(review.stars)].map((_, i) => (
                                        <FaStar key={i} />
                                    ))}
                                </div>
                                <div className="review-quote">
                                    <FaQuoteLeft className="quote-icon" />
                                    <p>"{review.content}"</p>
                                </div>
                            </motion.div>
                        ))}
                    </div>

                    <div className="text-center mt-50">
                        <a 
                            href="https://www.google.com/search?q=RoulezPropre+avis" 
                            target="_blank" 
                            rel="noreferrer" 
                            className="btn-google-trust"
                        >
                            <FaGoogle style={{ marginRight: '10px' }} />
                            Voir tous les avis Google
                        </a>
                    </div>
                </div>
            </section>

            {/* Instagram Social Wall Section - Proposition 1 */}
            <section className="instagram-section-premium">
                <div className="container">
                    <motion.div 
                        className="section-header text-center"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                    >
                        <span className="section-label">RÉSEAUX SOCIAUX</span>
                        <h2 className="section-title">SUIVEZ-NOUS SUR <span className="text-gradient-blue">INSTAGRAM</span></h2>
                        <p className="section-subtitle-text">Découvrez nos coulisses, nos vidéos detaling et nos dernières réalisations en direct.</p>
                    </motion.div>

                    <div className="insta-grid-premium">
                        {/* Post 1 - Reel */}
                        <motion.div 
                            className="insta-card-premium"
                            initial={{ opacity: 0, scale: 0.9 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true }}
                            whileHover={{ y: -10 }}
                        >
                            <a href="https://www.instagram.com/reel/DV9COS8isQy/" target="_blank" rel="noreferrer" className="insta-link-wrapper">
                                <div className="insta-img-placeholder">
                                    <img src={luxe5} alt="Instagram Reel RoulezPropre" />
                                    <div className="insta-overlay-icon">
                                        <FaInstagram />
                                        <span>VOIR LE REEL</span>
                                    </div>
                                </div>
                                <div className="insta-card-info">
                                    <div className="insta-user">
                                        <img src={creatorImg} alt="Avatar" className="insta-avatar" />
                                        <span>@roulezpropre</span>
                                    </div>
                                    <p className="insta-caption">Transformation d'un intérieur luxe... ✨ #detailing #meulan</p>
                                </div>
                            </a>
                        </motion.div>

                        {/* Post 2 - Profile / Follow Card */}
                        <motion.div 
                            className="insta-card-premium follow-card-highlight"
                            initial={{ opacity: 0, scale: 0.9 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true }}
                            transition={{ delay: 0.1 }}
                            whileHover={{ y: -10 }}
                        >
                            <a href="https://www.instagram.com/roulezpropre" target="_blank" rel="noreferrer" className="insta-link-wrapper">
                                <div className="insta-follow-content">
                                    <div className="insta-logo-glow">
                                        <FaInstagram />
                                    </div>
                                    <h3>REJOIGNEZ LA COMMUNAUTÉ</h3>
                                    <p>@roulezpropre</p>
                                    <div className="insta-stats-mockup">
                                        <div className="stat"><strong>1.2k</strong><span>Abonnés</span></div>
                                        <div className="stat"><strong>150+</strong><span>Posts</span></div>
                                    </div>
                                    <span className="btn-insta-follow">S'ABONNER</span>
                                </div>
                            </a>
                        </motion.div>

                        {/* Post 3 - Regular Post */}
                        <motion.div 
                            className="insta-card-premium"
                            initial={{ opacity: 0, scale: 0.9 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true }}
                            transition={{ delay: 0.2 }}
                            whileHover={{ y: -10 }}
                        >
                            <a href="https://www.instagram.com/p/DS5d1WlitOF/" target="_blank" rel="noreferrer" className="insta-link-wrapper">
                                <div className="insta-img-placeholder">
                                    <img src={luxe7} alt="Instagram Post RoulezPropre" />
                                    <div className="insta-overlay-icon">
                                        <FaInstagram />
                                        <span>VOIR LE POST</span>
                                    </div>
                                </div>
                                <div className="insta-card-info">
                                    <div className="insta-user">
                                        <img src={creatorImg} alt="Avatar" className="insta-avatar" />
                                        <span>@roulezpropre</span>
                                    </div>
                                    <p className="insta-caption">Le souci du détail, jusque dans les moindres recoins. 👌</p>
                                </div>
                            </a>
                        </motion.div>
                    </div>

                    <div className="insta-footer-cta text-center mt-50">
                        <p>Plus de contenus exclusifs ?</p>
                        <div className="social-pills">
                            <a href="https://tiktok.com/@roulezpropre" target="_blank" rel="noreferrer" className="pill-btn tiktok"><FaTiktok /> TikTok</a>
                            <a href="https://facebook.com/roulezpropre" target="_blank" rel="noreferrer" className="pill-btn facebook"><FaFacebook /> Facebook</a>
                        </div>
                    </div>
                </div>
            </section>

            <FAQSection />
        </div>
    );
};

export default HomePage;
